module.exports = __webpack_public_path__ + "static/media/fwms.49102820.png";